import { useState } from 'react';

export function useInput<T>(initialValue: T, name?: string) {
  const [value, setValue] = useState(initialValue);

  return {
    value,
    setValue,
    reset: () => setValue(initialValue),
    bind: {
      value,
      name,
      onChange: (event: any) => {
        setValue(event.target.value);
      },
      setValue: (val: T) => setValue(val),
    },
  };
}
